export enum StudyType {
  MECHANISTIC = 'MECHANISTIC',

  TOXICOLOGICAL = 'TOXICOLOGICAL',

  EPIDEMIOLOGICAL = 'EPIDEMIOLOGICAL',

  ECOTOXICOLOGY = 'ECOTOXICOLOGY',
}
